import {BrowserModule, BrowserTransferStateModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';


import {OrderButtonComponent} from './order-button/order-button.component';
import {ProductCarouselComponent} from './product-carousel/product-carousel.component';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';

import {HttpClient, HttpClientModule} from '@angular/common/http';
import {HttpFactory} from './shared/factory/http-factory';
import {LanguageService} from './services/language/language.service';
import {RouterModule, Routes} from '@angular/router';
import {PlaySportsDetailsComponent} from './detail-pages/play-sports-details/play-sports-details.component';
import {ProductDetailIntroComponent} from './detail-pages/product-detail-intro/product-detail-intro.component';
import {ProductDetailOfferComponent} from './detail-pages/product-detail-offer/product-detail-offer.component';
import {TvshopHeaderComponent} from './shared/tvshop-header/tvshop-header.component';
import {TvshopComponent} from './tv-shop-component/tv-shop-component';
import {PriceComponent} from './shared/price/price.component';
import {
  PlaySportsDetailGridItemComponent
} from './detail-pages/product-detail-offer/play-sports-detail-grid-item/play-sports-detail-grid-item.component';
import {ArrowComponent} from './shared/arrow-component/arrow.component';
import {
  ProductDetailEntertainmentComponent
} from './detail-pages/product-detail-entertainment/product-detail-entertainment.component';
import {
  ProductDetailOrderOptionsComponent
} from './detail-pages/product-detail-order-options/product-detail-order-options.component';
import {
  ProductOrderOptionComponent
} from './detail-pages/product-detail-order-options/product-order-option/product-order-option.component';
import {NavigationService} from './services/navigation/navigation.service';
import {LoginService} from './services/login/login.service';
import {Environment} from './shared/environment/environment';
import {AppComponent} from './app.component';
import {LocalApiService} from './services/local-api/local-api.service';
import {ResourceService} from './services/resource/resource.service';
import {OcapiService} from './services/ocapi/ocapi.service';
import {WebsocketService} from './services/websocket/websocket.service';
import {RxJsWebSocketService} from './services/websocket/rxjs-websocket-service';
import {StbWebSocketService} from './services/websocket/stb-websocket.service';
import {PlayDetailsComponent} from './detail-pages/play-details/play-details.component';
import {RtlSeriesDetailsComponent} from './detail-pages/rtl-series-details/rtl-series-details.component';
import {BeTvSportsDetailsComponent} from './detail-pages/be-tv-sports/be-tv-sports-details.component';
import {ProductDetailInfoComponent} from './detail-pages/product-detail-info/product-detail-info.component';
import {BeTvDetailsComponent} from './detail-pages/be-tv/be-tv-details.component';
import {OptionFrDetailsComponent} from './detail-pages/option-fr/option-fr-details.component';
import {ModalComponent} from './modals/ordering-modals/input-pincode-modal/input-pincode-modal.component';
import {
  InputPincodeComponent
} from './modals/ordering-modals/input-pincode-modal/input-pincode/input-pincode.component';
import {ConditionsModalComponent} from './modals/conditions-modal/conditions-modal.component';
import {OrderSucceededComponent} from './modals/ordering-modals/order-succeeded/order-succeeded.component';
import {OrderFailedComponent} from './modals/ordering-modals/order-failed/order-failed.component';
import {
  OrderingModalManagerComponent
} from './modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import {PlayMoreDetailsComponent} from './detail-pages/play-more-details/play-more-details.component';
import {PassionXlDetailsComponent} from './detail-pages/passion-xl/passion-xl-details.component';
import {EntertainmentPackService} from './services/entertainment-pack/entertainment-pack-service';
import {NavigableButtonComponent} from './shared/navigable-button/navigable-button.component';
import {StompConfig, StompService} from '@stomp/ng2-stompjs';
import * as SockJS from 'sockjs-client';
import {PincodeServiceFactory} from './services/pincode/pincode-service-factory';
import {OverlayMessageComponent} from './shared/overlay-message/overlay-message.component';
import {SpinnerLoaderComponent} from './shared/spinner-loader/spinner-loader.component';
import {CACHE, CacheLoader, CacheModule, CacheService, CacheStaticLoader} from '@ngx-cache/core';
import {BrowserCacheModule, MemoryCacheService} from '@ngx-cache/platform-browser';
import {ErrorPageComponent} from './shared/error-page/error-page.component';
import {OrderMessageComponent} from './modals/ordering-modals/order-message/order-message.component';
import {DeepLinkingComponent} from './deep-linking/deep-linking.component';
import {DeepLinkingOptionComponent} from './deep-linking/deep-linking-option/deep-linking-option.component';
import {EdsIdMapperService} from './services/eds-id-mapper/eds-id-mapper.service';
import {InfoMaintenanceComponent} from './shared/info-maintenance/info-maintenance.component';
import {MaintenanceService} from './services/maintenance/maintenance-service';
import {MaintenancePageComponent} from './maintenance-page/maintenance-page.component';
import {MaintenancePropertyMapper} from './services/maintenance/maintenance-property-mapper';
import {ApiGatewayService} from './services/ocapi/api-gateway.service';
import {SilentAuthService} from './services/ocapi/silent-auth.service';
import {SofyService} from './services/sofy/sofy.service';
import {FamilyFunDetailsComponent} from './detail-pages/family-fun-details/family-fun-details.component';
import {BouquetArabeDetailsComponent} from './detail-pages/bouquet-arabe-details/bouquet-arabe-details.component';
import {
  BouquetAfricainDetailsComponent
} from './detail-pages/bouquet-africain-details/bouquet-africain-details.component';
import {DiscoverMoreDetailsComponent} from './detail-pages/discover-more-details/discover-more-details.component';
import {OmapiService} from './services/omapi/omapi.service';
import {EntertainmentPackUtils} from './shared/utils/entertainmentpack/entertainment-pack-utils';
import {ChangeLogComponent} from './change-log/change-log.component';
import {TrialPageComponent} from './detail-pages/trial-page/trial-page.component';
import {FindTrialCodeModalComponent} from './modals/trial-modals/find-trial-code-modal/find-trial-code-modal.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TrialSuccessModalComponent} from './modals/trial-modals/trial-success-modal/trial-success-modal.component';
import {TrialModalManagerComponent} from './modals/trial-modals/trial-modal-manager/trial-modal-manager.component';
import {TrialCodeModalComponent} from './modals/trial-modals/trial-code-modal/trial-code-modal.component';
import {InputTrialCodeComponent} from './modals/trial-modals/input-trial-code/input-trial-code.component';
import {TrialComparisonComponent} from './modals/trial-modals/trial-comparison/trial-comparison.component';
import {
  TrialComparisonButtonComponent
} from './modals/trial-modals/trial-comparison/trial-comparison-button/trial-comparison-button.component';
import {SpinnerModalComponent} from './shared/spinner-modal/spinner-modal.component';
import {
  PlayTrailerButtonComponent
} from './detail-pages/product-detail-intro/play-trailer-button/play-trailer-button.component';
import {TrailerComponent} from './detail-pages/product-detail-intro/trailer/trailer.component';
import {AnalyticsService} from './services/analytics/analytics.service';
import {
  TrialAttemptsReachedModalComponent
} from './modals/trial-modals/trial-attempts-reached-modal/trial-attempts-reached-modal.component';
import {
  TrialActivationPendingModalComponent
} from './modals/trial-modals/trial-activation-pending-modal/trial-activation-pending-modal.component';
import {
  OverlayMessageTrailerComponent
} from './detail-pages/product-detail-intro/trailer/overlay-message-trailer/overlay-message-trailer.component';
import {CarouselItemComponent} from './tv-shop-component/carousel-item/carousel-item.component';
import {NavigableBannerComponent} from './tv-shop-component/navigable-banner/navigable-banner.component';
import {VrtNetGemistDetailsComponent} from './detail-pages/vrt-net-gemist/vrt-net-gemist-details.component';
import {RedCarpetMoreDetailsComponent} from './detail-pages/red-carpet-more-details/red-carpet-more-details.component';
import {PriceDetailComponent} from './shared/price/price-detail.component';
import {UserTypeDataService} from './services/user-type/user-type.data.service';
import {OcapiAsynchronousService} from './services/ocapi/ocapi.asynchronous.service';
import {OcapiSynchronousService} from './services/ocapi/ocapi.synchronous.service';
import {CommonModule} from '@angular/common';
import {
  NetflixServicesDetailsComponent
} from './detail-pages/netflix-services-details/netflix-services-details.component';
import {FaqsComponent} from './shared/faqs/faqs.component';
import {SpacerComponent} from './shared/spacer/spacer.component';
import {CtaLinkComponent} from './shared/cta-link/cta-link.component';
import {QrTileComponent} from './shared/qr-tile/qr-tile.component';
import {FaqsItemComponent} from './shared/faqs/faqs-item/faqs-item.component';
import {
  StreamingBundleOptionsComponent
} from './detail-pages/netflix-services-details/streaming-bundle-options/streaming-bundle-options.component';
import {BadgeComponent} from './shared/badge/badge.component';
import {FaqsModalComponent} from './modals/faqs-modal/faqs-modal.component';
import {CheckboxCardComponent} from './checkbox/checkbox-card/checkbox-card.component';
import {ContainerComponent} from './shared/container/container.component';
import {
  StandaloneFlavorsComponent
} from './detail-pages/netflix-services-details/standalone-flavors/standalone-flavors.component';
import {
  StandaloneFlavorOptionComponent
} from './detail-pages/netflix-services-details/standalone-flavors/standalone-flavor-option/standalone-flavor-option.component';
import {TermsAndConditionsModal} from './modals/terms-and-conditions-modal/terms-and-conditions-modal.component';
import {BadgeDynamicClassesDirective} from './shared/badge/directives/badge-dynamic-classes.directive';
import {DisneyServicesDetailsComponent} from './detail-pages/disney-service-details/disney-services-details.component';
import {StreamzBasicDetailsComponent} from './detail-pages/streamz-basic-details/streamz-basic-details.component';
import {PackOptionSelectionComponent} from './shared/pack-option-selection/pack-option-selection.component';
import {PackOptionComponent} from './shared/pack-option-selection/pack-option/pack-option.component';

const appRoutes: Routes = [
  {path: 'index.html', component: TvshopComponent, pathMatch: 'full'},
  {path: '', redirectTo: 'index.html', pathMatch: 'full'},
  {path: 'salesoffer:id', component: DeepLinkingComponent},
  {path: 'salesoffer', component: DeepLinkingComponent},
  {path: 'status/change-log', component: ChangeLogComponent}
];

const stompConfig: StompConfig = {
  url: () => {
    return new SockJS(Environment.environmentConfig().baseApiUrl + '/ocapi/notify/');
  },
  headers: {},
  heartbeat_in: 0,
  heartbeat_out: 20000,
  reconnect_delay: 5000,
  debug: true
};

export function cacheFactory(): CacheLoader {
  return new CacheStaticLoader({
    key: 'NGX_CACHE',
    lifeSpan: {
      'expiry': Number.MAX_VALUE, // mil
      'TTL': Number.MAX_VALUE // seconds
    }
  });
}

@NgModule({
  declarations: [
    TvshopComponent,
    NavigableBannerComponent,
    CarouselItemComponent,
    FaqsItemComponent,
    ProductCarouselComponent,
    PlaySportsDetailsComponent,
    PlayDetailsComponent,
    PlayMoreDetailsComponent,
    PassionXlDetailsComponent,
    BeTvDetailsComponent,
    BeTvSportsDetailsComponent,
    OptionFrDetailsComponent,
    ProductDetailIntroComponent,
    ProductDetailOfferComponent,
    TvshopHeaderComponent,
    AppComponent,
    PriceComponent,
    PriceDetailComponent,
    PlaySportsDetailGridItemComponent,
    ArrowComponent,
    ProductDetailEntertainmentComponent,
    ProductDetailOrderOptionsComponent,
    ProductOrderOptionComponent,
    StandaloneFlavorOptionComponent,
    OrderButtonComponent,
    ModalComponent,
    InputPincodeComponent,
    ConditionsModalComponent,
    FaqsModalComponent,
    TermsAndConditionsModal,
    OrderSucceededComponent,
    OrderingModalManagerComponent,
    RtlSeriesDetailsComponent,
    OverlayMessageComponent,
    PackOptionSelectionComponent,
    PackOptionComponent,
    ProductDetailInfoComponent,
    NavigableButtonComponent,
    OrderFailedComponent,
    SpinnerLoaderComponent,
    ErrorPageComponent,
    OrderMessageComponent,
    DeepLinkingComponent,
    DeepLinkingOptionComponent,
    InfoMaintenanceComponent,
    MaintenancePageComponent,
    DiscoverMoreDetailsComponent,
    FamilyFunDetailsComponent,
    NetflixServicesDetailsComponent,
    DisneyServicesDetailsComponent,
    BouquetArabeDetailsComponent,
    BouquetAfricainDetailsComponent,
    ChangeLogComponent,
    TrialPageComponent,
    TrialModalManagerComponent,
    TrialCodeModalComponent,
    InputTrialCodeComponent,
    FindTrialCodeModalComponent,
    TrialSuccessModalComponent,
    TrialComparisonComponent,
    TrialComparisonButtonComponent,
    SpinnerModalComponent,
    TrialActivationPendingModalComponent,
    TrialAttemptsReachedModalComponent,
    PlayTrailerButtonComponent,
    TrailerComponent,
    OverlayMessageTrailerComponent,
    VrtNetGemistDetailsComponent,
    RedCarpetMoreDetailsComponent,
    BadgeComponent,
    FaqsComponent,
    SpacerComponent,
    CtaLinkComponent,
    QrTileComponent,
    StreamingBundleOptionsComponent,
    StandaloneFlavorsComponent,
    CheckboxCardComponent,
    ContainerComponent,
    BadgeDynamicClassesDirective,
    StreamzBasicDetailsComponent
  ],

  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BrowserTransferStateModule,
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    BrowserCacheModule.forRoot([
      {
        provide: CACHE,
        useClass: MemoryCacheService
      }
    ]),
    CacheModule.forRoot({
      provide: CacheLoader,
      useFactory: (cacheFactory)
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpFactory.createTranslateHttpLoader,
        deps: [HttpClient]
      }
    })
  ],

  providers: [
    TranslateService,
    LanguageService,
    LoginService,
    NavigationService,
    LocalApiService,
    ResourceService,
    EntertainmentPackService,
    OcapiService,
    OcapiAsynchronousService,
    OcapiSynchronousService,
    UserTypeDataService,
    {provide: 'PincodeService', useFactory: PincodeServiceFactory.createPincodeService, deps: [LocalApiService]},
    WebsocketService,
    RxJsWebSocketService,
    StbWebSocketService,
    StompService,
    CacheService,
    {
      provide: StompConfig,
      useValue: stompConfig
    },
    EdsIdMapperService,
    MaintenanceService,
    ApiGatewayService,
    SilentAuthService,
    SofyService,
    MaintenancePropertyMapper,
    OmapiService,
    EntertainmentPackUtils,
    AnalyticsService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  entryComponents: [
    PlayMoreDetailsComponent,
    PlaySportsDetailsComponent,
    PlayDetailsComponent,
    StreamzBasicDetailsComponent,
    RtlSeriesDetailsComponent,
    OptionFrDetailsComponent,
    BeTvDetailsComponent,
    BeTvSportsDetailsComponent,
    PassionXlDetailsComponent,
    DiscoverMoreDetailsComponent,
    FamilyFunDetailsComponent,
    NetflixServicesDetailsComponent,
    DisneyServicesDetailsComponent,
    BouquetArabeDetailsComponent,
    BouquetAfricainDetailsComponent,
    VrtNetGemistDetailsComponent,
    TrialPageComponent,
    RedCarpetMoreDetailsComponent,
    DeepLinkingComponent,
    ChangeLogComponent,
    StreamingBundleOptionsComponent,
    StandaloneFlavorsComponent,
    PackOptionSelectionComponent,
    PackOptionComponent
  ]
})

export class AppModule {
}
